import HeroCarousel, { type HeroSlideItem } from '@/pages/home/components/HeroCarousel';
import QuickEntries from '@/pages/home/components/QuickEntries';
import LatestSection from '@/pages/home/components/LatestSection';
import PopularSection from '@/pages/home/components/PopularSection';
import AboutSection from '@/pages/home/components/AboutSection';
import { getMovieById } from '@/lib/movies';
import { heroSlides } from '@/mocks/hero';
import { useSeo } from '@/hooks/useSeo';

export default function Home() {
  useSeo({
    title: '麻豆传媒视频－最新影视资源与精彩视频内容平台',
    description:
      '麻豆传媒视频提供丰富的影视资源与精彩视频内容，覆盖电视剧、电影等多种类型，满足用户多样化观看需求。欢迎访问麻豆传媒视频，探索更多精彩影视世界。',
    keywords: '麻豆传媒视频,影视,电影,电视剧,视频资源,影视资讯,热门影视',
  });

  const slides: HeroSlideItem[] = heroSlides
    .map((slide) => {
      const movie = getMovieById(slide.movieId);
      return movie ? { movie, banner: slide.banner } : null;
    })
    .filter((item): item is HeroSlideItem => item !== null);

  return (
    <div className="w-full">
      <HeroCarousel slides={slides} />
      <QuickEntries />
      <LatestSection />
      <PopularSection />
      <AboutSection />
    </div>
  );
}